import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchArticles = (params = {}) =>
    axios.get(`${API}/articles`, { params }).then((r) => r.data);

export const fetchArticle = (slug) =>
    axios.get(`${API}/articles/${slug}`).then((r) => r.data);

export const fetchCategories = () =>
    axios.get(`${API}/categories`).then((r) => r.data);

export const subscribeNewsletter = (email) =>
    axios.post(`${API}/newsletter`, { email }).then((r) => r.data);

export const fetchMonetization = () =>
    axios.get(`${API}/monetization`).then((r) => r.data);
